module.exports = __webpack_public_path__ + "img/add-money-wallet-icon.5719a00f.svg";